var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MatFieldComponent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EventTimeService } from '../../../../services/event.time.service';
import { ImageService } from '../../../../services/image.service';
import { AllFrontendSettingsStore, VisitorTripNotifyAddOrRemoveItemStore, } from '../../../../stores/visitor.calendar.store';
import { VisitorTripSideBarComponent } from '../trip.side.bar/visitor.trip.side.bar.component';
import { VisitorTripComponent } from '../visitor.trip.component';
import { StyleModel } from '../../../../commands/hub/style.command';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
var VisitorTripCardComponent = /** @class */ (function (_super) {
    __extends(VisitorTripCardComponent, _super);
    function VisitorTripCardComponent(router, formBuilder, imageService, parent, allFrontendSettingsStore, notifyAddOrRemoveItemStore, visitorTripComponent, editorChoiceStore, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.formBuilder = formBuilder;
        _this.imageService = imageService;
        _this.parent = parent;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.notifyAddOrRemoveItemStore = notifyAddOrRemoveItemStore;
        _this.visitorTripComponent = visitorTripComponent;
        _this.editorChoiceStore = editorChoiceStore;
        _this.activatedRoute = activatedRoute;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.titleBgColor = '#49659f';
        _this.isAddingNewTrip = false;
        _this.addTo = new EventEmitter();
        _this.removeFrom = new EventEmitter();
        _this.locateOnMap = new EventEmitter();
        _this.showDetails = new EventEmitter();
        _this.isMultiDateEvent = false;
        _this.isInAnyTrip = false;
        _this.isAddingSuccess = [];
        _this.inTripStatus = [];
        _this.style = new StyleModel();
        _this.editorChoiceText = "EDITOR'S CHOICE";
        return _this;
    }
    VisitorTripCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.tripFormGroup = this.formBuilder.group({
            tripTitle: [null, [Validators.required]],
        });
        if (this.itemType === 'event') {
            this.item = this.item;
            if (this.item.eventTimes && this.item.eventTimes.length > 1) {
                this.isMultiDateEvent = true;
            }
            this.processEventTime(this.item);
        }
        else if (this.itemType === 'tour') {
            this.item = this.item;
            var attract = this.item;
            this.item.attractions = attract.attraction;
            this.totalStop = this.item.stops || this.item.attractions.filter(function (x) { return x.status !== 'not found'; }).length;
            this.totalTime = this.item.travelTime ? EventTimeService.convertToTravelTimeText(this.item.travelTime) : null;
        }
        this.notifyAddOrRemoveItemStore.notifyCommand.takeUntil(this.isDestroyed).subscribe(function (item) {
            _this.checkIsInAnyTrip();
        });
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.style) {
                _this.style = command.style;
            }
        });
        this.editorChoiceTextHandler();
    };
    Object.defineProperty(VisitorTripCardComponent.prototype, "isNoTripCreatedYet", {
        get: function () {
            this.parent.loadTripsInLocalStorage();
            return !this.parent.trips || !this.parent.trips.length;
        },
        enumerable: true,
        configurable: true
    });
    VisitorTripCardComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe(function (editorChoice) {
            if (!!_this.item['startTime']) {
                _this.editorChoiceText = editorChoice.editorChoiceForEvent;
            }
            else {
                _this.editorChoiceText = editorChoice.editorChoiceForPlace;
            }
        });
    };
    VisitorTripCardComponent.prototype.checkIsInAnyTrip = function () {
        var _this = this;
        this.parent.loadTripsInLocalStorage();
        if (!this.parent.trips || !this.parent.trips.length) {
            return false;
        }
        this.isInAnyTrip = false;
        this.parent.trips.forEach(function (trip) {
            if (trip.attractions.any(function (x) { return x.item.id === _this.item.id; })) {
                _this.isInAnyTrip = true;
            }
        });
    };
    VisitorTripCardComponent.prototype.openTripModal = function () {
        var _this = this;
        this.parent.showCreateTripModal(false, this.item, this.itemType, function () {
            _this.showAddingToTripSuccess(0, 2000);
        });
    };
    VisitorTripCardComponent.prototype.openTripMenu = function () {
        var _this = this;
        if (this.item['isOnlineEvent']) {
            alert('Online events cannot be added to your trips');
            return;
        }
        this.getInTripStatus();
        if (this.isNoTripCreatedYet) {
            this.openTripModal();
            this.menuTrigger.closeMenu();
            return;
        }
        this.parent.trips.forEach(function (x) {
            _this.isAddingSuccess.push(false);
        });
        this.menuTrigger.openMenu();
    };
    VisitorTripCardComponent.prototype.getInTripStatus = function () {
        var _this = this;
        this.inTripStatus = [];
        var trips = this.parent.loadTripsInLocalStorage();
        if (!trips || !trips.trips || !trips.trips.length) {
            return null;
        }
        for (var _i = 0, _a = trips.trips; _i < _a.length; _i++) {
            var trip = _a[_i];
            var isInTrip = trip.attractions.any(function (x) { return x.item.id === _this.item.id; });
            this.inTripStatus.push(isInTrip);
        }
    };
    VisitorTripCardComponent.prototype.exitAddingNewTrip = function ($event) {
        $event && $event.stopPropagation && $event.stopPropagation()();
        this.isAddingNewTrip = false;
    };
    VisitorTripCardComponent.prototype.addNewTrip = function ($event) {
        var _this = this;
        //$event.stopPropagation();
        this.isAddingNewTrip = true;
        setTimeout(function () {
            _this.tripTitle.focus();
        });
    };
    VisitorTripCardComponent.prototype.saveNewTrip = function () {
        this.parent.createNewTrip(this.newTripTitle, this.item, this.itemType);
        this.menuTrigger.closeMenu();
        this.newTripTitle = '';
        this.isAddingNewTrip = false;
    };
    VisitorTripCardComponent.prototype.addOrRemoveFromTrip = function ($event, tripIndex) {
        $event.stopPropagation();
        //if (this.isInTrip(tripIndex)) {
        if (this.inTripStatus[tripIndex]) {
            this.parent.removeFromTrip(this.item._id, tripIndex);
            this.inTripStatus[tripIndex] = false;
        }
        else {
            this.parent.addItemToTrip({ item: this.item, type: this.itemType, tripIndex: tripIndex });
            this.inTripStatus[tripIndex] = true;
        }
        this.showAddingToTripSuccess(tripIndex);
        this.checkIsInAnyTrip();
        this.notifyAddOrRemoveItemStore.notifyCommand.next(null);
    };
    VisitorTripCardComponent.prototype.showAddingToTripSuccess = function (index, showTime) {
        var _this = this;
        if (showTime === void 0) { showTime = 1000; }
        this.isAddingSuccess = [];
        this.parent.trips.forEach(function (x) {
            _this.isAddingSuccess.push(false);
        });
        this.isAddingSuccess[index] = true;
        setTimeout(function () {
            _this.isAddingSuccess[index] = false;
        }, showTime);
        setTimeout(function () {
            _this.menuTrigger.closeMenu();
        }, 900);
    };
    VisitorTripCardComponent.prototype.isInTrip = function (tripIndex) {
        return this.parent.isInTrip(tripIndex, this.item._id);
    };
    VisitorTripCardComponent.prototype.newTripFieldFocus = function ($event) {
        $event.stopPropagation();
    };
    VisitorTripCardComponent.prototype.addItem = function ($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.addTo.emit({ item: this.item, event: $event });
    };
    VisitorTripCardComponent.prototype.removeItem = function ($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.removeFrom.emit(this.item);
    };
    VisitorTripCardComponent.prototype.showOnMap = function ($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.locateOnMap.emit(this.item);
    };
    VisitorTripCardComponent.prototype.viewDetails = function ($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.showDetails.emit(this.item);
    };
    VisitorTripCardComponent.prototype.processEventTime = function (event) {
        if (event.startTimeText) {
            if (!this.isMultiDateEvent) {
                this.detailDate = EventTimeService.getDateFromTimeText(event.startTimeText);
                this.detailTime = EventTimeService.getTimeFromTimeText(event.startTimeText, event.timezone);
            }
            else {
                var startDate = EventTimeService.getDateFromTimeText(event.startTimeText);
                var endDate = EventTimeService.getDateFromTimeText(event.endTimeText);
                this.detailDate = startDate + (endDate ? ' - ' + endDate : '');
            }
        }
        else {
            if (!this.isMultiDateEvent) {
                this.detailDate = EventTimeService.getDateFromTime(event.startTime);
                this.detailTime = EventTimeService.getTimeFromTime(event.startTime);
            }
            else {
                var startDate = EventTimeService.getDateFromTime(event.startTime);
                var endDate = EventTimeService.getDateFromTime(event.endTime);
                this.detailDate = startDate + (endDate ? ' - ' + endDate : '');
            }
        }
    };
    return VisitorTripCardComponent;
}(BaseComponent));
export { VisitorTripCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.card/visitor.trip.card.component.ts.pre-build-optimizer.js